<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="pt_task">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_task || "任务名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pt_task }}
          </div>
        </div>
        <employee-field  v-if="form.main.pt_taskstatus == '待启动'"
          :label="customLabel.pt_emname || '任务处理人'"
          v-model="form.main.pt_emname"
          @select="onSelectEmployee"
          slot="pt_emname"
        />
        <div class="weui-cell" v-else slot="pt_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_emname || "任务处理人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pt_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="pt_planenddate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_planenddate || "要求完成日期"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd'">
            {{ form.main.pt_planenddate }}
          </div>
        </div>
        <div class="weui-cell" slot="pt_taskstatus">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_taskstatus || "任务状态"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pt_taskstatus }}
          </div>
        </div>
        <div class="weui-cell" slot="pt_fbcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_fbcode || "问题反馈单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pt_fbcode }}
          </div>
        </div>
        <div class="weui-cell" slot="pt_reason">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_reason || "问题原因"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.pt_reason"
              placeholder="请输入问题原因"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-cell" slot="pt_result">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_result || "处理方法"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.pt_result"
              placeholder="请输入处理方法"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-cell" slot="pt_actbegindate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_actbegindate || "实际开始时间"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd'">
            {{ form.main.pt_actbegindate }}
          </div>
        </div>
        <div class="weui-cell" slot="pt_actenddate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_actenddate || "实际完成时间"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd'">
            {{ form.main.pt_actenddate }}
          </div>
        </div>
        <div class="weui-cell" slot="pt_actworkhour">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_actworkhour || "实际工时"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pt_actworkhour }}
          </div>
        </div>
        <div class="weui-cell" slot="pt_pjcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_pjcode || "项目单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pt_pjcode }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_dename">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_dename }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_emname || "项目负责人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_emtel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_emtel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_emtel }}
          </div>
        </div>
        <div class="weui-cell" slot="pt_rpname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pt_rpname || "项目阶段"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pt_rpname }}
          </div>
        </div>
        <div class="weui-cell" slot="pp_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pp_emname || "阶段负责人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pp_emname }}
          </div>
        </div>
      </custom-layout>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.pt_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        v-if="form.main.pt_taskstatus == '待启动'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="startTask"
        >启动</a
      >
      <a
        href="javascript:;"
        v-if="form.main.pt_taskstatus == '已启动'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()" 
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    EmployeeField,
    FileField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/plm/problemtask",
      codeField: "pt_code",
      statusField: "pt_statuscode",
      caller: "PlmProblemTask",
      xtype: "plm-problemtask-formpanel",
      form: {
        main: {
          pt_emid: null,
          pt_task: null,
          pt_emname: null,
          pt_planenddate: null,
          pt_taskstatus: null,
          pt_fbcode: null,
          pt_reason: null,
          pt_result:null,
          pt_actbegindate:null,
          pt_actenddate:null,
          pt_actworkhour:null,
          pt_pjcode:null,
          pj_dename:null,
          pj_emname:null,
          pj_emtel:null,
        },
      },
    };
  },
  methods: {
    onSelectEmployee(selection){
      var me = this,
        main = me.form.main;
      main.pt_emid = selection.id;
    },
    startTask() {
      let me = this,
        main = me.form.main,
        id = main.id;
      me.$loading({
        url: "/api/plm/problemtask/startTask/" + id,
        method: "POST",
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("任务启动成功!");
          // 刷新页面以显示最新的数据 
          setTimeout(() => {
            me.$router.go(0);
          }, 1000);
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main;
      if (!main.pt_emname) {
        me.$weui.topTips("请选择任务处理人", 2000);
      } else {
        me.p_save();
      }
    },
  },
};
</script>
